module.exports = __webpack_public_path__ + "img/horizontal_6_5_7005.14a8cfba.png";